import { CommonUtilsContext } from 'contexts/commonUtils';
import { MobileAppContext } from 'modules/mobileApp/context';
import { forwardRef, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsEventName } from 'api/analytics';
import { useTheme } from 'hooks/theme';
import { slidesData } from './helpers';
import { useAnalytics } from 'helpers/analytics';
import { ModalDefaultProps } from 'components/Modal';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';
import { AppSlide, AppSlideProps } from './components/AppSlide';
import { DownloadAndroidApp } from 'components/DownloadAndroidApp';
import { ModalTemplate } from 'components/ModalTemplate';
import { Slider, SliderArrow } from 'components/Slider';

import { ScInstallSteps } from './styled';

export const MobileAppModal = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const { t } = useTranslation('mobileApp');
    const { grayColor6 } = useTheme();
    const { isMobileS } = useContext(CommonUtilsContext);
    const { sendEventToAnalytics } = useAnalytics();
    const { data } = useContext(MobileAppContext);

    const modalSettings: ModalTemplateSettings = useMemo(() => {
      return isMobileS
        ? { type: 'mobile', mode: { type: 'default' } }
        : {
            type: 'desktop',
            size: 'large',
            mode: { type: 'default' },
          };
    }, [isMobileS]);

    const handleAndroidClick = () => {
      sendEventToAnalytics({
        name:
          AnalyticsEventName.MODAL__MOBILE_APP_PAGE__ANDROID_APP_ICON__LINK__CLICK,
      });
    };

    const slides = slidesData.map((image, index) => ({
      image,
      index,
    }));

    return (
      <ModalTemplate
        ref={ref}
        settings={modalSettings}
        title={t('steps.title')}
        onClose={onClose}
      >
        <ScInstallSteps slidesNumber={slides.length}>
          <div className="steps-wrp">
            <Slider<AppSlideProps>
              key="slider"
              slides={slides}
              loop
              pagination={{ clickable: true }}
              slide={({ image, index }) => (
                <AppSlide image={image} index={index} />
              )}
              slidesPerView={1}
              slidesPerGroup={1}
              speed={1800}
              withArrows={{
                type: SliderArrow.INSIDE,
                alwaysVisible: true,
                leftArrowPosition: {
                  top: '47%',
                  left: '0',
                },
                rightArrowPosition: {
                  top: '47%',
                  right: '0',
                },
                bgArrowButtons: grayColor6,
              }}
            />
          </div>
          {data?.showAndroid && data?.androidApk && (
            <div className="button-wrp">
              <DownloadAndroidApp
                onClick={handleAndroidClick}
                width={168}
                height={56}
              />
            </div>
          )}
        </ScInstallSteps>
      </ModalTemplate>
    );
  }
);
